import React from "react";
import { Box, Center, Spinner } from "@chakra-ui/react";
import ComingSoon from "../pages/ComingSoon";

/**
 * ContentGuard component
 * Shows Coming Soon page if content is not available or loading
 * Shows the provided children if content is available
 */
const ContentGuard = ({
  children,
  isLoading = false,
  hasContent = true,
  fallbackMessage = null,
}) => {
  // Show loading spinner while fetching
  if (isLoading) {
    return (
      <Center minH="100vh">
        <Spinner size="xl" color="teal.500" />
      </Center>
    );
  }

  // Show Coming Soon if no content
  if (!hasContent) {
    return <ComingSoon message={fallbackMessage} />;
  }

  // Show the actual content
  return <Box>{children}</Box>;
};

export default ContentGuard;
